import axios from "axios";
// const urls = "http://api-test.mostup-alliance.io:8085";
// const urls = "https://console.mostup-alliance.io";
const urls = process.env.REACT_APP_BASE_URL;

// 로그인
export const requestLogin = (params) =>
  axios
    .post(`${urls}/mu/auth/signin`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

// 로그아웃
export const requestLogout = (params) =>
  axios
    .post(`${urls}/mu/user/signout`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

// 회원가입
export const requestSignUp = (params) =>
  axios
    .post(`${urls}/mu/auth/signup`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

// 회원 중복체크
export const requestAuthCheck = (params) =>
  axios
    .post(`${urls}/mu/auth/check`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

// 이메일 인증 요청
export const requestSendEmailConfirm = (params) =>
  axios
    .post(`${urls}/public/mail/url`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

// 회원탈퇴
export const requestWithdrawal = (params) =>
  axios
    .post(`${urls}/mu/user/leave`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//비밀번호 재설정(본인인증 이후, 로그인 못한 상태)
export const requestReSettingPassword = (params) =>
  axios
    .post(`${urls}/public/pwd/reset`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));
